import { createSlice } from "@reduxjs/toolkit";
import { DashboardResponse } from "../config";
import { doFetchData } from "./dashboard.action";

interface DashboardState {
  data: DashboardResponse["data"] | null;
  loading: boolean;
  error: string | null;
}

const initialState: DashboardState = {
  data: null,
  loading: false,
  error: null,
}

const DashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers:{},
  extraReducers: (builder) => {
    builder
    .addCase(doFetchData.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(doFetchData.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    })
    .addCase(doFetchData.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
  }
})

export default DashboardSlice.reducer;